import { Col, Row } from 'antd';
import CSS from 'csstype';
import React from 'react';

import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';

interface RowTitlesProps {
    level?: 1 | 2 | 3 | 4 | 5;
    firstText: string;
    secondText?: string;
    thirdText?: string;
    span?: number;
    offset?: string | number;
    style?: CSS.Properties;
    className?: string;
    paragraph?: boolean;
    secondParagraph?: boolean;
    bold?: boolean;
}

const thirdTextStyles = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    textAlign: 'right' as any,
    display: 'block',
    width: '100%'
};

// Pomocna komponenta abych mel prehlednejsiho akcionare, pouzitelna na vice mistech, v pripade potreby dodat dalsi props pro vice sloupcu a pod.
export const RowTitles: React.FC<RowTitlesProps> = ({
    firstText,
    paragraph,
    secondParagraph,
    level = 5,
    secondText,
    thirdText,
    span = 6,
    //   offset = 1,
    style,
    className,
    bold
}) => {
    return (
        <Row style={style} className={className} justify="space-between">
            <Col
                style={{
                    width: '100%'
                }}
                span={span}
            >
                {paragraph ? (
                    <Paragraph
                        text={firstText}
                        style={{
                            color: '#00000073',
                            ...(bold
                                ? {
                                      fontWeight: 600
                                  }
                                : {})
                        }}
                    />
                ) : (
                    <Title
                        level={level}
                        text={firstText}
                        style={{
                            fontSize: 16,
                            marginBottom: 0,
                            color: '#00000073'
                        }}
                    />
                )}
            </Col>
            {secondText && (
                <Col
                    style={
                        thirdText
                            ? {
                                  width: '100%'
                              }
                            : {}
                    }
                    span={thirdText ? 6 : undefined}
                >
                    {secondParagraph || paragraph ? (
                        <Paragraph
                            text={secondText}
                            style={{
                                ...(bold
                                    ? {
                                          fontWeight: 600
                                      }
                                    : {}),
                                ...(thirdText ? thirdTextStyles : {})
                            }}
                        />
                    ) : (
                        <Title level={level} text={secondText} style={thirdText ? thirdTextStyles : {}} />
                    )}
                </Col>
            )}
            {thirdText && (
                <Col
                    style={{
                        width: '100%'
                    }}
                    flex="end"
                    span={6}
                >
                    {secondParagraph || paragraph ? (
                        <Paragraph
                            text={thirdText}
                            style={{
                                ...(bold
                                    ? {
                                          fontWeight: 600
                                      }
                                    : {}),
                                textAlign: 'right',
                                display: 'block',
                                width: '100%'
                            }}
                        />
                    ) : (
                        <Title level={level} text={thirdText} style={thirdTextStyles} />
                    )}
                </Col>
            )}
        </Row>
    );
};
